import React from 'react';
import Slider from 'react-slick';

// Define arrows as components
const PrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: 'block', clear: 'both' }}
      onClick={onClick}
    >
      <svg
        xmlns='http://www.w3.org/2000/svg'
        height='32px'
        viewBox='0 -960 960 960'
        width='32px'
        fill='#434343'
      >
        <path d='M576-240 336-480l240-240 51 51-189 189 189 189-51 51Z' />
      </svg>
    </div>
  );
};

const NextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, padding: '20px', display: 'block', clear: 'both' }}
      onClick={onClick}
    >
      <svg
        xmlns='http://www.w3.org/2000/svg'
        height='32px'
        viewBox='0 -960 960 960'
        width='32px'
        fill='#434343'
      >
        <path d='M522-480 333-669l51-51 240 240-240 240-51-51 189-189Z' />
      </svg>
    </div>
  );
};

const BannerImageCarousel = ({ component, state }) => {
  console.log('BannerImageCarousel', component);
  const sliderSettings = {
    ...component?.settings,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
  };

  const settings = sliderSettings || {
    arrows: true,
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 2.5,
    slidesToScroll: 1,
    swipeToSlide: true,
  };

  //console.log("BannerImageCarousel component", settings, component);
  const classNamea = component?.section_id;
  const className = component?.section_id
    ? `banner-image-carousel ${classNamea.replace(' ', '-')}`
    : 'banner-image-carousel';
  return (
    <div className={className}>
      <div className='text-center mkt-section'>
        <div className='row'>
          <div className='col-xs-12'>
            {component?.title && (
              <h3 className='mkt-section-title'>{component?.title}</h3>
            )}
            {component?.sub_title && (
              <p className='mkt-section-subtitle'>{component?.sub_title}</p>
            )}
          </div>
        </div>
        <div className='carousel mkt-slider slider-container'>
          <Slider {...settings}>
            {component?.carousel_cards?.map((card, index) => (
              <>
                <a
                  className='carousel-item-wrapper'
                  href={card?.banner_url?.href}
                  target='_blank'
                  title={card?.banner_url?.title}
                >
                  <div className='carousel-item' key={index}>
                    <div className='carousel-item-img-wrapper'>
                      <img
                        src={card?.banner_image?.url}
                        alt={card?.banner_image_title}
                        className='img-fluid'
                      />
                    </div>
                    {card?.banner_image_title && (
                      <h5 className='title'>{card?.banner_image_title}</h5>
                    )}
                    {card?.banner_image_sub_title && (
                      <p className='discription'>
                        {card?.banner_image_sub_title}
                      </p>
                    )}
                  </div>
                </a>
              </>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default BannerImageCarousel;
